import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: #222;
  color: #fff;
  padding: 40px 20px;
`;

const FooterWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* Responsive layout: stack vertically on smaller screens */
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterLeft = styled.div`
  font-size: 14px;
`;

const SocialMedia = styled.div`
  display: flex;
  align-items: center;

  a {
    color: #fff;
    margin: 0 10px;
    font-size: 24px;
    transition: color 0.3s ease;

    &:hover {
      color: #fe88f1;
    }
  }

  /* Adjust spacing on smaller screens */
  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

const PrivacyLink = styled(Link)`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
  text-decoration: none;
  transition: color 0.2s ease;
  margin-top: 6px;
  display: block;

  &:hover {
    color: #fe88f1;
  }
`;

// Threads SVG icon (inline — react-icons/fa doesn't include Threads)
const ThreadsIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 192 192"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path d="M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.229c8.249.053 14.474 2.452 18.503 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.318-11.319 11.258-24.925 16.035-45.481 16.168-22.747-.148-39.926-7.48-51.06-21.795-10.268-13.217-15.554-32.48-15.716-57.25.162-24.771 5.448-44.032 15.716-57.25 11.134-14.314 28.313-21.647 51.06-21.795 22.95.15 40.5 7.52 52.171 21.905 5.73 7.158 10.028 16.143 12.862 26.672l16.143-4.305c-3.45-12.75-8.862-23.862-16.2-32.97C138.935 16.971 118.976 7.43 96.02 7.276h-.065C73.114 7.43 53.56 16.96 40.188 34.485 28.467 50.09 22.27 72.174 22.039 96.009c.231 23.835 6.428 45.919 18.149 61.523 13.372 17.525 32.926 27.056 56.628 27.21h.075c21.025-.137 37.843-5.822 50.274-16.9 15.588-13.818 16.583-32.12 11.003-43.068-4.31-8.453-11.793-14.658-21.631-18.787z" />
  </svg>
);

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterLeft>
          © {new Date().getFullYear()} MyCinemaDB. All rights reserved.
          <PrivacyLink to="/privacy">Privacy Policy</PrivacyLink>
        </FooterLeft>
        <SocialMedia>
          <a href="https://www.facebook.com/people/My-Cinema-DB/61572128786961/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href="https://x.com/mycinemadb" target="_blank" rel="noopener noreferrer" aria-label="X / Twitter">
            <FaTwitter />
          </a>
          <a href="https://www.instagram.com/mycinemadb/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.threads.net/@mycinemadb" target="_blank" rel="noopener noreferrer" aria-label="Threads">
            <ThreadsIcon />
          </a>
        </SocialMedia>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
